// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage-assigned-customers-parent-container{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.45);
    font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.manage-assigned-customers-container{
    width: 26vw;
    background-color: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
}
.manage-assigned-customers-container .header{
    margin: 0px;
    padding: 10px 16px;
    width: 100%;
    border-radius: 5px 5px 0px 0px;
    background-color: rgba(155, 30, 30, 0.952);
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
}
.manage-assigned-customers-container .header h1{
    margin: 0px;
    color: white;
    font-size: 22px;
    font-weight: 600;
}
.manage-assigned-customers-container .header p{
    margin: 0px;
    color: white;
    cursor: pointer;
    font-size: 22px;
    font-weight: 400;
}
.manage-assigned-customers-container .body{
    margin: 0px;
    padding: 10px 16px;
}
.manage-assigned-customers-container .body .assigned-customers-entry-container{
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 10px;
    background-color: rgb(245, 245, 245);
    border-bottom: 1px solid rgb(175, 175, 175);
}
.manage-assigned-customers-container .body .assigned-customers-entry-container:focus-within{
    border-bottom: 1px solid rgba(155, 30, 30, 0.952);
}
.manage-assigned-customers-container .body .assigned-customers-entry-container .assigned-customer-entry{
    margin: 4px 6px;
    padding: 4px 10px;
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    border-radius: 16px;
    color: rgb(59, 59, 59);
    background-color: rgb(204, 210, 218);
}
.manage-assigned-customers-container .body .assigned-customers-entry-container .assigned-customer-entry p{
    margin: 0px;
    font-size: 14px;
    cursor: pointer;
    margin-left: 8px;
}
.manage-assigned-customers-container .body .assigned-customers-entry-container input{
    flex: 1 1;
    min-width: 100px;
    margin: 4px 6px;
    outline: none;
    border: none;
    background-color: transparent;
    display: inline-flex;
}
.manage-assigned-customers-container .body .customers-browser-container{
    position: absolute;
    z-index: 1;
    top: 100%;
    max-height: 24vh;
    overflow-y: auto;
    width: 100%;
    display: none;
    margin-top: 2px;
    box-sizing: border-box;
    transform: translateX(-10px);
    background-color: white;
    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);
    border-radius: 0px 0px 4px 4px;
}
.manage-assigned-customers-container .body .customers-browser-container.active{
    display: block;
}
.manage-assigned-customers-container .body .customers-browser-container div{
    padding: 10px 12px;
    cursor: pointer;
    box-sizing: border-box;
    border-bottom: 1px solid rgb(230, 230, 230);
    transition: background-color 0.25s ease;
}
.manage-assigned-customers-container .footer{
    text-align: right;
    padding: 16px;
}
.manage-assigned-customers-container .footer button{
    padding: 8px 16px;
    margin-left: 24px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}
.manage-assigned-customers-container .footer .cancel-button{
    font-weight: 600;
    color: rgba(155, 30, 30, 0.952);
    background-color: rgb(232, 232, 232);
    transition: background-color 0.25s ease-in;
}
.manage-assigned-customers-container .footer .cancel-button:hover{
    background-color: rgb(212, 212, 212);
}
.manage-assigned-customers-container .footer .update-button.active{
    color: white;
    background-color: rgba(155, 30, 30, 0.952);
    transition: background-color 0.25s ease-in;
}
.manage-assigned-customers-container .footer .update-button.active:hover{
    background-color: rgba(179, 64, 64, 0.952);
}
.manage-assigned-customers-container .footer .update-button.inactive{
    cursor: default;
    font-weight: 600;
    color: rgb(163, 163, 163);
    background-color: rgb(232, 232, 232);
    transition: background-color 0.25s ease-in;
}`, "",{"version":3,"sources":["webpack://./src/styles/workspace_styles/TenantAdministratorStyles/Dashboards/ManageAssignedCustomers.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,4DAA4D;AAChE;AACA;IACI,WAAW;IACX,uBAAuB;IACvB,sCAAsC;IACtC,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,8BAA8B;IAC9B,0CAA0C;IAC1C,sBAAsB;IACtB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,2CAA2C;AAC/C;AACA;IACI,iDAAiD;AACrD;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,oCAAoC;AACxC;AACA;IACI,WAAW;IACX,eAAe;IACf,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,SAAO;IACP,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,YAAY;IACZ,6BAA6B;IAC7B,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,4BAA4B;IAC5B,uBAAuB;IACvB,6CAA6C;IAC7C,8BAA8B;AAClC;AACA;IACI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,2CAA2C;IAC3C,uCAAuC;AAC3C;AACA;IACI,iBAAiB;IACjB,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,oCAAoC;IACpC,0CAA0C;AAC9C;AACA;IACI,oCAAoC;AACxC;AACA;IACI,YAAY;IACZ,0CAA0C;IAC1C,0CAA0C;AAC9C;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,oCAAoC;IACpC,0CAA0C;AAC9C","sourcesContent":[".manage-assigned-customers-parent-container{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 10;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\r\n}\r\n.manage-assigned-customers-container{\r\n    width: 26vw;\r\n    background-color: white;\r\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n    border-radius: 5px;\r\n}\r\n.manage-assigned-customers-container .header{\r\n    margin: 0px;\r\n    padding: 10px 16px;\r\n    width: 100%;\r\n    border-radius: 5px 5px 0px 0px;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n.manage-assigned-customers-container .header h1{\r\n    margin: 0px;\r\n    color: white;\r\n    font-size: 22px;\r\n    font-weight: 600;\r\n}\r\n.manage-assigned-customers-container .header p{\r\n    margin: 0px;\r\n    color: white;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    font-weight: 400;\r\n}\r\n.manage-assigned-customers-container .body{\r\n    margin: 0px;\r\n    padding: 10px 16px;\r\n}\r\n.manage-assigned-customers-container .body .assigned-customers-entry-container{\r\n    position: relative;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    align-items: center;\r\n    padding: 10px;\r\n    background-color: rgb(245, 245, 245);\r\n    border-bottom: 1px solid rgb(175, 175, 175);\r\n}\r\n.manage-assigned-customers-container .body .assigned-customers-entry-container:focus-within{\r\n    border-bottom: 1px solid rgba(155, 30, 30, 0.952);\r\n}\r\n.manage-assigned-customers-container .body .assigned-customers-entry-container .assigned-customer-entry{\r\n    margin: 4px 6px;\r\n    padding: 4px 10px;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    border-radius: 16px;\r\n    color: rgb(59, 59, 59);\r\n    background-color: rgb(204, 210, 218);\r\n}\r\n.manage-assigned-customers-container .body .assigned-customers-entry-container .assigned-customer-entry p{\r\n    margin: 0px;\r\n    font-size: 14px;\r\n    cursor: pointer;\r\n    margin-left: 8px;\r\n}\r\n.manage-assigned-customers-container .body .assigned-customers-entry-container input{\r\n    flex: 1;\r\n    min-width: 100px;\r\n    margin: 4px 6px;\r\n    outline: none;\r\n    border: none;\r\n    background-color: transparent;\r\n    display: inline-flex;\r\n}\r\n.manage-assigned-customers-container .body .customers-browser-container{\r\n    position: absolute;\r\n    z-index: 1;\r\n    top: 100%;\r\n    max-height: 24vh;\r\n    overflow-y: auto;\r\n    width: 100%;\r\n    display: none;\r\n    margin-top: 2px;\r\n    box-sizing: border-box;\r\n    transform: translateX(-10px);\r\n    background-color: white;\r\n    box-shadow: 0px 0px 8px rgba(80, 80, 80, 0.4);\r\n    border-radius: 0px 0px 4px 4px;\r\n}\r\n.manage-assigned-customers-container .body .customers-browser-container.active{\r\n    display: block;\r\n}\r\n.manage-assigned-customers-container .body .customers-browser-container div{\r\n    padding: 10px 12px;\r\n    cursor: pointer;\r\n    box-sizing: border-box;\r\n    border-bottom: 1px solid rgb(230, 230, 230);\r\n    transition: background-color 0.25s ease;\r\n}\r\n.manage-assigned-customers-container .footer{\r\n    text-align: right;\r\n    padding: 16px;\r\n}\r\n.manage-assigned-customers-container .footer button{\r\n    padding: 8px 16px;\r\n    margin-left: 24px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n.manage-assigned-customers-container .footer .cancel-button{\r\n    font-weight: 600;\r\n    color: rgba(155, 30, 30, 0.952);\r\n    background-color: rgb(232, 232, 232);\r\n    transition: background-color 0.25s ease-in;\r\n}\r\n.manage-assigned-customers-container .footer .cancel-button:hover{\r\n    background-color: rgb(212, 212, 212);\r\n}\r\n.manage-assigned-customers-container .footer .update-button.active{\r\n    color: white;\r\n    background-color: rgba(155, 30, 30, 0.952);\r\n    transition: background-color 0.25s ease-in;\r\n}\r\n.manage-assigned-customers-container .footer .update-button.active:hover{\r\n    background-color: rgba(179, 64, 64, 0.952);\r\n}\r\n.manage-assigned-customers-container .footer .update-button.inactive{\r\n    cursor: default;\r\n    font-weight: 600;\r\n    color: rgb(163, 163, 163);\r\n    background-color: rgb(232, 232, 232);\r\n    transition: background-color 0.25s ease-in;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
